<template>
  <div>
    {{ productTypeId | CategoryToString }}
  </div>
</template>

<script>
export default {
  props: ["rowData"],
  computed: {
    productTypeId() {
      return this.rowData?.product_type_id; // eslint-disable-line camelcase
    },
  },
};
</script>
